<template>
  <div class="fileContent">
    <div style="margin:18px 0">
      <Breadcrumb />
    </div>
    <div class="searchForm">
      <Form ref="caseForm" :dataSource="getData" id="caseForm">
        <template v-slot:button>
          <div style="text-align: right;margin-top:4px;">
            <a-button type="primary" @click="search">
              查询
            </a-button>
            <a-button :style="{ marginLeft: '8px' }" @click="reset">
              重置
            </a-button>
          </div>
        </template>
      </Form>
    </div>
    <div class="increase" style="padding:32px 0 10px 0;position: relative;min-height:74px">
      <a-button type="primary" @click="increaseItem" style="position: absolute;top:32px;left:0;">
        新增公告
      </a-button>
    </div>
    <div class="table" style="background: #fff;border-radius: 2px;">
      <a-table
        :columns="columns"
        :data-source="data"
        @change="changePage"
        :loading="loading"
        :pagination="pagination"
        :rowKey="
          (record) => {
            record.process_base_id
          }
        "
      >
        <span slot="name" slot-scope="text, data1, index">{{ index + 1 }}</span>
        <span slot="action" slot-scope="text, data2">
          <a @click="show('fund', data2)">查看</a>
        </span>
      </a-table>
    </div>
  </div>
</template>

<script>
import Form from '@/components/GlobalForm'
import Breadcrumb from '@/components/breadcrumb'
import { forms } from './formData'
import { service } from './service'
import { checkIdCard } from '@/utils/checkFun'

const columns = [
  {
    title: '项目编号',
    dataIndex: 'num',
    key: 'num',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '时间',
    dataIndex: 'process_base_draft_date',
    key: 'process_base_draft_date'
  },
  {
    title: '公告名称',
    dataIndex: 'report_message_name',
    key: 'report_message_name',
    ellipsis: true
  },
  {
    title: '公告类型',
    dataIndex: 'report_message_type',
    key: 'report_message_type',
    ellipsis: true
  },
  {
    title: '创建人',
    dataIndex: 'drafterName',
    key: 'drafterName',
    ellipsis: true
  },
  // {
  //   title: '状态',
  //   dataIndex: 'process_status',
  //   key: 'process_status',
  //   ellipsis: true
  // },
  {
    title: '操作',
    key: 'action',
    width: '80px',
    scopedSlots: { customRender: 'action' }
  }
]
export default {
  name: 'Index',
  components: {
    Breadcrumb,
    Form
  },
  data() {
    return {
      columns,
      params: {},
      isShow: false, // 身份证号输入框是否展示
      inputNumber: '',
      data: [], // 列表数据
      activeData: [], // 活动帮扶
      pagination: {
        // 分页
        current: 1,
        pageSize: 12,
        total: 0,
        showTotal: (total) => `共 ${total} 条数据`
      },
      loading: false
    }
  }, // 面包屑
  computed: {
    // 获取查询的form表单
    getData() {
      return forms.getFormData({}, this)
    }
  },
  mounted() {
    this.getProcessList({
      process_label: 'Done',
      pageIndex: 1,
      pageSize: this.pagination.pageSize,
      process_config_type: 'reportMessage'
    })
  },
  methods: {
    // 分页切换
    changePage(pagination) {
      this.pagination.current = pagination.current
      this.getProcessList({
        process_label: 'Done',
        pageIndex: pagination.current,
        pageSize: this.pagination.pageSize,
        process_config_type: 'reportMessage',
        ...this.params
      })
    },
    // 查询
    search() {
      let params = {}
      // console.log(params)
      params = this.$refs.caseForm.getFieldsValue()
      this.pagination.current = 1
      this.params = params
      this.getProcessList({
        process_label: 'Done',
        pageIndex: 1,
        pageSize: this.pagination.pageSize,
        process_config_type: 'reportMessage',
        ...params
      })
    },
    // 重置
    reset() {
      this.$refs.caseForm.resetFields()
    },
    // 新增项目,帮扶申请
    increaseItem() {
      this.$router.push({
        path: '/assit/contentManagement/increaseReport',
        query: { pageType: 'launch' }
      })
    },
    // 数字输入框
    numberChange(value, id) {
      let newValue = value
      newValue = newValue.replace(/[^\d]/g, '') // 清除“数字”和“.”以外的字符
      newValue = newValue.replace(/^\./g, '') // 验证第一个字符是数字而不是.
      newValue = newValue.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的.
      newValue = newValue
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      setTimeout(() => {
        this.$refs.caseForm.setFieldsValue(id, newValue)
      }, 0)
    },
    // 校验身份证号是否合法
    checkIdCard(rule, value, callback) {
      // const form = this.$refs.caseForm
      if (value && !checkIdCard(value)) {
        const title = '请输入正确的身份证号'
        callback(title)
      } else {
        callback()
      }
    },
    // 获取流程列表
    getProcessList(data) {
      this.loading = true
      this.data = []
      service.getProcessList(data).then((response) => {
        this.data = response.data || []
        this.pagination.total = response.total || 0
        this.loading = false
      })
    },
    show(assitType, record) {
      // 根据流程类型判断跳到哪个界面
      let type = 'approval'
      const params = {
        process_base_work_number: record.process_base_work_number,
        process_base_status: record.process_base_status
      }
      if (record.process_base_status && record.process_base_status === 'Approval') {
        // 判断流程状态类型
        type = 'view'
      } else if (record.process_base_status && record.process_base_status === 'ReturnDraft') {
        type = 'relaunch'
      } else if (record.process_base_status && record.process_base_status === 'Draft') {
        type = 'draft'
      } else if (
        record.process_base_status &&
        (record.process_base_status === 'Finish' || record.process_base_status === 'Termination')
      ) {
        type = 'view'
      }
      this.$router.push({
        path: '/assit/contentManagement/increaseReport',
        query: { pageType: type, processData: JSON.stringify(params) }
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '../../style.less';
.fileContent {
  .searchForm {
    background: #fff;
    padding: 24px 20px 11px;
    /*margin:24px 0 11px 0;*/
  }
}
</style>
